'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var language_en_US = require('../../consts/language_en_US.js');
var LanguageProvider = require('../../providers/LanguageProvider.js');

const generateTokensFromObject = function () {
  let obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return obj ? Object.entries(obj).map(_ref => {
    let [key, value] = _ref;
    return (typeof value === 'string' || typeof value === 'number') && {
      token: `{{${key}}}`,
      value: `${value}`
    };
  }).filter(Boolean) : [];
};
const langKeys = language_en_US["default"];
const replaceTokens = (content, replacementTokens) => {
  let newContent = content;
  replacementTokens.forEach(_ref2 => {
    let {
      token,
      value
    } = _ref2;
    newContent = newContent.replace(token, `${value}`);
  });
  return newContent;
};

// Since this hook is just returning the raw string it's encouraged you use the <Language />
// component instead as it handles safe html markup rendering for JSX as well
const useLanguage = _ref3 => {
  let {
    langKey,
    replacementTokens = [],
    defaultString
  } = _ref3;
  const customStrings = React.useContext(LanguageProvider.LanguageContext);
  if (!langKey) return {
    value: undefined
  };
  const keys = {
    ...langKeys,
    ...customStrings
  };
  const updatedValue = replaceTokens(keys[langKey] || '', replacementTokens);
  if (!customStrings[langKey] && defaultString) {
    return {
      value: replaceTokens(defaultString, replacementTokens),
      rawValue: defaultString
    };
  }
  return {
    value: updatedValue,
    rawValue: `${keys[langKey]}`
  };
};

exports["default"] = useLanguage;
exports.generateTokensFromObject = generateTokensFromObject;
exports.replaceTokens = replaceTokens;
